import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { ZpaAccesses } from "./accesses.ts";
import { ZpaComponents } from "./components.ts";

const ZpaFilters = {
  "application-segment": { keys: ["id", "name"] },
  tenant: { keys: ["id"] },
} as const satisfies AnyFilterSchema;
export type ZpaFilters = typeof ZpaFilters;

export const ZpaRegistration = Registration({
  accesses: ZpaAccesses,
  category: "resource",
  components: ZpaComponents,
  docs: { install: "zscaler", request: "zscaler/requesting-access" },
  filters: ZpaFilters,
  identifier: "name",
  itemKind: "customer",
  label: "Zscaler Private Access",
  logoUrl: "https://avatars.githubusercontent.com/u/1709408?s=200&v=4",
  maturity: "preview",
  requestType: "requestable",
  useMapping: [
    { use: "iam_write", component: "iam-write" },
    { use: "network_access", component: "network-access" },
  ],
});

registerIntegration("zscaler-private-access", ZpaRegistration);
